export const endpoints = {
    Login: "api/users/auth",
    forgetPassword: "api/users/forgot-password",
    DoctorProfile: "api/doctors/profile",
    HealthPersonProfile: "api/sites/profile",
    upDateProfile: "api/doctors/profile",
    AddDocter: "api/doctors/",
    SetPassword: "api/users/set-password",
    verifyOtp: "api/users/validateOtp",
    resendOtp: "api/users/resendOtp",
    AdminProfile: "api/users/profile",
    ListOfHospitals: "api/hospitals/list"
} as const;

// To define types for the keys (endpoints)
export type Endpoint = keyof typeof endpoints;